const headerItems = [
  {
    label: 'About',
    slug: 'about',
    href: '/#',
  },
  // {
  //   label: 'Gallery',
  //   slug: 'gallery',
  //   href: '/gallery',
  // },
  // {
  //   label: 'Learning',
  //   slug: 'learning',
  //   href: '/learning',
  // },
  // {
  //   label: 'FAQs',
  //   slug: 'faqs',
  //   href: '/FAQs',
  // },
  // {
  //   label: "RAWGraphs 1.3",
  //   slug: 'rawgraphs-1-3',
  //   href: 'https://app.rawgraphs.io',
  // },
  // {
  //   label: 'GitHub',
  //   slug: 'github',
  //   href: '/app',
  // },
]

export default headerItems
